import * as React from "react";
import RestoredArchivesCell from "data-lake/data-lake-overview/cells/RestoredArchivesCell";
import Routes from "routing/Routes";
import { Link } from "components/common";
import DaysOfData from "./cells/DaysOfData";
const customColumnRenderers = () => ({
  attributes: {
    stream_id: {
      renderCell: (_stream_id, dataLake) => /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(dataLake.stream_id)}?segment=destinations` }, dataLake.stream_title),
      width: 2
    },
    days_of_data: {
      renderCell: (_days_of_data, dataLake) => /* @__PURE__ */ React.createElement(DaysOfData, { dataLake }),
      staticWidth: "matchHeader"
    },
    message_count: {
      staticWidth: "matchHeader"
    },
    restored_indices: {
      renderCell: (_restored_indices, archive) => /* @__PURE__ */ React.createElement(RestoredArchivesCell, { archive }),
      staticWidth: "matchHeader"
    }
  }
});
export default customColumnRenderers;
